module.exports = __webpack_public_path__ + "static/phone1-6aff5524ef5d483d45de8f0e274c5832.png";